import { render, staticRenderFns } from "./DetailPage2.vue?vue&type=template&id=468b1b6b"
import script from "./DetailPage2.vue?vue&type=script&lang=js"
export * from "./DetailPage2.vue?vue&type=script&lang=js"
import style0 from "./DetailPage2.vue?vue&type=style&index=0&id=468b1b6b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports